import store from '../store'

export function checkAuthentication(to, from, next) {
    if(store.getters['auth/isAuthenticated']===false || store.getters['auth/isAuthenticated']===null){
        next({name :'Login'});
    } else {
        next();
    }
}

